import * as React from 'react';

import { VALID_MEDIA_STYLES } from '../Utils';

import { IIDescriptionContentTheme } from './DescriptionGroup';
import { IDescriptionListCommonProps } from './DescriptionList';

// LIST CONTEXT
export interface IDescriptionListContext extends IDescriptionListCommonProps {
  align?: VALID_MEDIA_STYLES;
  direction: {
    base: 'row' | 'column';
    small: 'row' | 'column';
  };
  stacked?: boolean;
  contentOrderSwitch?: boolean;
}

export const DescriptionListContext = React.createContext<IDescriptionListContext>({
  align: 'right',
  direction: { base: 'row', small: 'row' },
  noMobileStack: false,
  contentOrderSwitch: false,
  fixTermWidth: undefined,
});

export const useDescriptionListContext = () => React.useContext(DescriptionListContext);

// GROUP CONTEXT
export interface IDescriptionGroupContext {
  detail?: IIDescriptionContentTheme;
  term?: IIDescriptionContentTheme;
  variant?: 'large' | 'small';
}

export const DescriptionGroupContext = React.createContext<IDescriptionGroupContext>({
  detail: {},
  term: {},
});

export const useDescriptionGroupContext = () => React.useContext(DescriptionGroupContext);
